export const enum TransferStatus { Incoming, Fail, Connecting, Transferring, Transferred, Success, Canceled }

export const enum CheckinStatus {
	New = "new",
	Accepted = "accepted",
	Importing = "importing",
	Imported = "imported",
	Transferred = "transferred"
}
